import Vue from "vue";
import Amplify from "aws-amplify";
import { components } from "aws-amplify-vue";
import JsonViewer from "vue-json-viewer";
import App from "./App.vue";
import {
  Alert,
  Button,
  Divider,
  Form,
  Icon,
  Input,
  Layout,
  Menu,
  message,
  Radio,
  Select,
  Spin,
  Switch,
  Table,
  DatePicker
} from "ant-design-vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

Amplify.configure({
  Auth: {
    // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL,

    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region
    identityPoolRegion: process.env.VUE_APP_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_USER_POOL,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_APP,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: false,
    mandatorySignIn: true,

    // // OPTIONAL - Configuration for cookie storage
    // // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
    // cookieStorage: {
    // // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //     domain: '.yourdomain.com',
    // // OPTIONAL - Cookie path
    //     path: '/',
    // // OPTIONAL - Cookie expiration in days
    //     expires: 365,
    // // OPTIONAL - Cookie secure flag
    // // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    //     secure: true
    // },

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: "USER_PASSWORD_AUTH"
  }
});

Vue.use(Alert);
Vue.use(Button);
Vue.use(Divider);
Vue.use(Form);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Radio);
Vue.use(Radio.Group);
Vue.use(Select);
Vue.use(Spin);
Vue.use(Switch);
Vue.use(Table);
Vue.use(JsonViewer);
Vue.use(DatePicker);

Vue.prototype.$message = message;

new Vue({
  router,
  store,
  render: h => h(App),
  components: {
    ...components
  }
}).$mount("#app");
